import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'capitalize',
    standalone: false
})
export class CapitalizePipe implements PipeTransform {

  transform(value: any, words: boolean) {
    var first: any;
    if (value) {
      if (words) {
        return value.replace(/\b\w/g, first.toLocaleUpperCase());
      } else {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }

    return value;
  }
}